"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChanges = exports.tableDataToJson = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
function tableDataToJson(tableData) {
    const [names, ...values] = tableData;
    const reduceCallback = (result, value, index) => {
        result[names[index]] = value;
        return result;
    };
    return values.map((row) => {
        return row.reduce(reduceCallback, {});
    });
}
exports.tableDataToJson = tableDataToJson;
/* eslint-enable @typescript-eslint/no-explicit-any */
function getChanges(initial, updates, fieldToSkip) {
    return Object.entries(updates).reduce((result, [key, value]) => {
        if (key !== fieldToSkip && initial[key] !== value) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            result[key] = value;
        }
        return result;
    }, {});
}
exports.getChanges = getChanges;
